import { faArrowDownShortWide, faArrowUpWideShort, faMagnifyingGlass } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import moment from 'moment';
import React, {useState} from 'react';
import { Row, 
    Col, 
    Container,
    InputGroup,
    FormControl,
    Form, 
    ButtonGroup,
    Button,
    DropdownButton,
    Dropdown} from 'react-bootstrap';

export default function CommunFilters(props)
{
    const [startdate, setStartDate] = useState(props.date_value);
    const [enddate, setEndDate] = useState(props.date_end_value);

    const list_sort_ops = props.sort_ops.map((ops, index) => 
        <option key={index} value={ops.value}>{ops.label}</option>
    );

    const list_filters = props.filters.map((f,index) => 
        <Dropdown.Item key={index} onClick={() => props.setRangeFilter(index)}>{f}</Dropdown.Item>
    )

    return(
        <Container fluid>
            <Row className='p-2'>
                <Col xs={12} sm={12} md={6} lg={6} xl={3} xxl={3}>
                    <InputGroup>
                        <InputGroup.Text id="search-filter">
                            <FontAwesomeIcon icon={faMagnifyingGlass}/>
                        </InputGroup.Text>
                        <FormControl
                        placeholder={props.search_ph}
                        aria-label="search"
                        aria-describedby="search-filter"
                        value={props.search_value}
                        onChange={(e) => props.setSearch(e.target.value)}
                        disabled={props.disabled}
                        />
                    </InputGroup>
                </Col>
                <Col xs={12} sm={12} md={6} lg={6} xl={3} xxl={3} className="displayflex">
                    <InputGroup>
                        <InputGroup.Text>
                            Ordenar
                        </InputGroup.Text>
                        <Form.Select 
                        value={props.sort_filter_value} 
                        onChange={(e) => props.setSortFilter(e.target.value)}
                        disabled={props.disabled}
                        defaultValue={moment().format("YYYY-MM-DD")}
                        >
                            {list_sort_ops}
                        </Form.Select>
                    </InputGroup>&#8195;
                    <ButtonGroup>
                        <Button
                            variant={props.sort_filter_type === 1 ? 'dark' : 'outline-dark'}
                            onClick={() => props.setSortFilterType(1)}
                        ><FontAwesomeIcon icon={faArrowDownShortWide}/></Button>
                        <Button
                            variant={props.sort_filter_type === -1 ? 'dark' : 'outline-dark'}
                            onClick={() => props.setSortFilterType(-1)}
                        ><FontAwesomeIcon icon={faArrowUpWideShort}/></Button>
                    </ButtonGroup>
                </Col>
                <Col xs={12} sm={12} md={12} lg={12} xl={6} xxl={6}>
                    <InputGroup>
                        <DropdownButton
                        as={InputGroup.Prepend}
                        variant="outline-secondary"
                        title={props.filters[props.range_filter_value]}
                        >
                            {list_filters}
                        </DropdownButton>
                        { props.range_filter_value === 0 ? 
                        <>
                        <FormControl 
                            type="date" 
                            placeholder="Fecha Inicio"
                            value={startdate}
                            onChange={(e) => setStartDate(e.target.value)}
                            disabled={props.disabled}
                            max={enddate}
                        />
                        <FormControl 
                            type="date" 
                            placeholder="Fecha Final"
                            value={enddate}
                            onChange={(e) => setEndDate(e.target.value)}
                            disabled={props.disabled}
                            min={startdate}
                        />
                        </> : <></>}
                        <Button variant="outline-dark" onClick={() => props.setDateFilter(startdate, enddate)} disabled={props.disabled}>
                            Buscar
                        </Button>
                    </InputGroup>
                </Col>
            </Row>
        </Container>
    );
}